// extracted by mini-css-extract-plugin
export default {"columnsSetupViewSettings":"ColumnsSetupViewSettings_columnsSetupViewSettings__FKsv2","viewAccess":"ColumnsSetupViewSettings_viewAccess__+Go0H"};